import { CreditFrameworkResource } from 'app/_resources/credit-framework.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ConfirmModal } from 'app/_services/confirm-modal.factory';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { bind } from 'app/_decorators/bind.decorator';
import { FeatureToggles } from 'angular/resources/feature-toggles.resource';

class OperatorSettingsCreditFrameworkCtrl implements ng.IController {
    private static readonly DISPLAY_CREDITLIMITS = 10;

    private creditFramework: any;
    public isNewFramework: boolean;
    public uniqueFrameworkNames: any;
    private originalFramework: CreditFrameworkDto;
    public creditPanelExpanded: boolean = false;
    private onDelete: any;
    private onCreate: any;
    public orderBy: string = 'identifier';
    public reverseOrder: boolean = false;
    public itemsPerPage: number =
        OperatorSettingsCreditFrameworkCtrl.DISPLAY_CREDITLIMITS;
    public filteredCreditLimits: CreditLimitDto[];
    public filterLoginRange: any = {};
    public colFiltOpts: any = {};

    public sortComparator = (v1, v2) => {
        if (
            this.orderBy === 'staticLimitValue.value' ||
            this.orderBy === 'usedLimitValue.value'
        )
            return parseFloat(v1.value) < parseFloat(v2.value) ? -1 : 1;

        if (v1.type !== 'string' || v2.type !== 'string') {
            return v1.index < v2.index ? -1 : 1;
        }

        return v1.value.localeCompare(v2.value);
    };

    constructor(
        private creditFrameworkResource: CreditFrameworkResource,
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private confirmModal: ConfirmModal,
        private $rootScope: angular.IRootScopeService & {
            featureToggles: FeatureToggles;
        }
    ) {}

    $onInit(): void {
        if (!this.isNewFramework) {
            if (this.creditFramework.applicableAuctionTypes.length > 0) {
                this.creditFramework.applyPrimary = true;
            }
            if (this.creditFramework.secondaryAndFcfsDurations.length > 0) {
                this.creditFramework.applySecondaryFcfs = true;
            }
            this.originalFramework = angular.copy(this.creditFramework);
        } else {
            this.creditFramework = {
                refLabel: '',
                applicableAuctionTypes: [],
                creditFactors: {
                    YEAR: {
                        value: 1,
                        floatingPointNumber: true
                    },
                    QUARTER: {
                        value: 1,
                        floatingPointNumber: true
                    },
                    MONTH: {
                        value: 1,
                        floatingPointNumber: true
                    },
                    DAY: {
                        value: 1,
                        floatingPointNumber: true
                    },
                    WITHINDAY: {
                        value: 1,
                        floatingPointNumber: true
                    }
                },
                secondaryAndFcfsDurations: []
            };
        }
    }

    public createCreditFramework() {
        const creditFrameworkDto = angular.copy(this.creditFramework);
        delete creditFrameworkDto.applyPrimary;
        delete creditFrameworkDto.applySecondaryFcfs;
        this.creditFrameworkResource.createCreditFramework(
            creditFrameworkDto,
            (savedCreditLimit: CreditFrameworkDto) => {
                this.uniqueFrameworkNames.push(creditFrameworkDto.refLabel);
                this.onCreate({ creditFramework: creditFrameworkDto });
                this.growl.show('Successfully created.', 'success', {
                    delay: 2000
                });
                this.isNewFramework = !this.isNewFramework;
            },
            this.errorHandler
        );
    }

    public saveCreditFramework() {
        const creditFrameworkDto = angular.copy(this.creditFramework);
        delete creditFrameworkDto.applyPrimary;
        delete creditFrameworkDto.applySecondaryFcfs;

        this.creditFrameworkResource.updateCreditFramework(
            creditFrameworkDto,
            (savedCreditLimit: CreditFrameworkDto) => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }

    public compareOriginal() {
        return angular.equals(this.originalFramework, this.creditFramework);
    }

    public discardChanges() {
        this.creditFramework = angular.copy(this.originalFramework);
    }

    public applyCreditFrameworkToAuctions() {
        if (this.creditFramework.applyPrimary) {
            this.creditFramework.applicableAuctionTypes = [
                'YEAR',
                'QUARTER',
                'MONTH',
                'DAY',
                'WITHINDAY'
            ];
        } else {
            this.creditFramework.applicableAuctionTypes = [];
            this.creditFramework.applyPrimary = false;
        }
    }

    public applyCreditFrameworkToAuctionType(type) {
        if (this.creditFramework.applicableAuctionTypes.indexOf(type) != -1) {
            this.creditFramework.applicableAuctionTypes.splice(
                this.creditFramework.applicableAuctionTypes.indexOf(type),
                1
            );
            if (this.creditFramework.applicableAuctionTypes.length == 0) {
                this.creditFramework.applyPrimary = false;
            }
        } else {
            this.creditFramework.applicableAuctionTypes.push(type);
        }
    }

    public applyCreditFrameworkToSecondrayFcfs() {
        if (this.creditFramework.applySecondaryFcfs) {
            this.addNewSecondaryFcfsDuration();
        } else {
            this.creditFramework.secondaryAndFcfsDurations = [];
            this.creditFramework.applySecondaryFcfs = false;
        }
    }

    public addNewSecondaryFcfsDuration() {
        let newSecondaryFcfsDuration: any = {
            factor: {
                value: '1.00',
                floatingPointNumber: true
            },
            durationFrom: 1,
            durationTo: 1
        };
        this.creditFramework.secondaryAndFcfsDurations.push(
            newSecondaryFcfsDuration
        );
    }

    public removeSecondaryFcfsDuration(index) {
        if (this.creditFramework.secondaryAndFcfsDurations.length > 1) {
            this.creditFramework.secondaryAndFcfsDurations.splice(index, 1);
        }
    }

    public deleteCreditFramework(index) {
        if (this.creditFramework.creditLimits.length > 0) {
            // this.growl.show("Can not delete Credit Framework if Credit Limits are assigned.", "danger")
        } else {
            this.askForConfirmation().result.then(() => {
                this.creditFrameworkResource.deleteCreditFramework(
                    { refId: this.creditFramework.refId },
                    () => {
                        this.growl.show('Successfully deleted.', 'success', {
                            delay: 2000
                        });
                        this.onDelete();
                    },
                    this.errorHandler
                );
            });
        }
    }

    public askForConfirmation(
        text: string = 'Are you sure you want to delete this credit framework?'
    ): angular.ui.bootstrap.IModalInstanceService {
        return this.confirmModal(text);
    }

    public isCollapsed(elem: string, refId: number): boolean {
        return angular.element(elem + '_' + refId).hasClass('collapse in');
    }

    @bind
    public filterDateRange(value) {
        if (
            !this.filterLoginRange.startDate &&
            !this.filterLoginRange.endDate
        ) {
            return true;
        }

        const start = moment(value.interval.start);
        const end = moment(value.interval.end);

        if (this.filterLoginRange.startDate && this.filterLoginRange.endDate) {
            return (
                start.isSameOrAfter(moment(this.filterLoginRange.startDate)) &&
                end.isBefore(moment(this.filterLoginRange.endDate))
            );
        }

        if (this.filterLoginRange.startDate) {
            return start.isSameOrAfter(moment(this.filterLoginRange.startDate));
        }

        if (this.filterLoginRange.endDate) {
            return end.isBefore(moment(this.filterLoginRange.endDate));
        }
        return false;
    }
}

angular.module('app').component('pkpOperatorSettingsCreditFramework', {
    controller: OperatorSettingsCreditFrameworkCtrl,
    template:
        require('app/operator-settings/operator-settings-credit-framework.component.html'),
    bindings: {
        isNewFramework: '=',
        creditFramework: '<',
        onDelete: '&',
        onCreate: '&',
        uniqueFrameworkNames: '='
    }
});
